import { SHOW_FILTER, HIDE_FILTER, TOGGLE_FILTER } from './types';

// SHOW
export const showFilter = () => {
  return {
    type: SHOW_FILTER,
  };
};

// HIDE
export const hideFilter = () => {
  return {
    type: HIDE_FILTER,
  };
};

// TOGGLE
export const toggleFilter = () => {
  return {
    type: TOGGLE_FILTER,
  };
};
